import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Components
import {
    Grid,
    TextField,
    Checkbox,
    FormHelperText
} from '@material-ui/core';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    textField: {
        minWidth: '100%',
    },
    gridHelperText: {
        padding: '0px !important',
    },
    helperText: {
        margin: '0 22px 0'
    }
});



class FormFieldMultiAzienda extends Component {
    constructor(props) {
        super(props);

        this.onMultiChange = this.onMultiChange.bind(this);
    }

    onMultiChange(newValue) {

        if (newValue) {
            this.props.manageChangeFormField('codice_azienda', '');  //se è multiazienda il codiceAzienda rimane vuoto
        }

        this.props.manageChangeFormField('multiazienda', newValue);
    }


    render() {
        const { classes, valueMultiAzienda, valueCodiceAzienda, helperText, manageChangeFormField } = this.props;

        return (
            <Grid container spacing={2}>
                <Grid item xs={2} sm={2} className={classes.alignLeft}>
                    <Checkbox
                        checked={valueMultiAzienda}
                        onChange={e => this.onMultiChange(e.target.checked)}
                        color="primary"
                    />
                </Grid>
                <Grid item xs={10} sm={10}>
                    {valueMultiAzienda === false ?
                        <TextField
                            className={classes.textField}
                            variant="outlined"
                            size="small"
                            label="Codice Azienda"
                            value={valueCodiceAzienda}
                            onChange={e => manageChangeFormField('codice_azienda', e.target.value)}
                            error={helperText !== '' ? true : false}
                        />
                        :
                        null
                    }
                </Grid>
                {helperText !== '' ?
                    <Grid item xs={12} sm={12} className={classes.gridHelperText}>
                        <FormHelperText
                            error={helperText !== '' ? true : false}
                            className={classes.helperText}
                        >
                            {helperText}
                        </FormHelperText>
                    </Grid>
                    : null
                }
            </Grid>
        );
    }
}

FormFieldMultiAzienda.propTypes = {
    manageChangeFormField: PropTypes.func.isRequired,

    valueMultiAzienda: PropTypes.bool.isRequired,
    valueCodiceAzienda: PropTypes.string.isRequired,
    helperText: PropTypes.string.isRequired,
};

export default withStyles(styles)(FormFieldMultiAzienda);